import React, { useState, useEffect, useRef } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { SearchBar } from './styles';

interface Props {
  disabled?: string;
  show?: boolean;
  onSearch: (value: string) => void;
  onShowSearch?: (isSearch: boolean) => void;
  placeholder?: string;
  hasClose?: boolean;
  initialValue?: string;
  fullWidth?: boolean;
}

const Search = ({
  onSearch,
  onShowSearch,
  placeholder,
  disabled,
  hasClose = true,
  initialValue,
  fullWidth,
  show = true,
}: Props) => {
  const { t } = useStoreTranslation();
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    onSearch(initialValue ?? '');
  }, [initialValue]); // eslint-disable-line react-hooks/exhaustive-deps
  // TODO: check dependencies or refactor

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchQuery(value);
    onSearch(value);
  };

  const switchShowSearch = (show: boolean) => {
    if (onShowSearch) onShowSearch(show);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleBlur = () => {
    if (!searchQuery) {
      onSearch('');
      switchShowSearch(false);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleKeyDown = (event: React.KeyboardEvent) => {
    const ESC_KEY_CODE = 27;
    const escWasPressed = event.keyCode === ESC_KEY_CODE;

    if (escWasPressed) clearSearch();
  };

  const clearSearch = () => {
    switchShowSearch(false);
    setSearchQuery('');
    onSearch('');
  };

  const handleClickSearchBar = () => {
    if (!disabled) switchShowSearch(true);
  };

  return (
    <>
      {show && (
        <SearchBar fullWidth={fullWidth}>
          <SearchBar.Icon src={searchQuery ? '/images/search-bar/active.svg' : '/images/search-bar/disabled.svg'} />
          <SearchBar.InputContainer onClick={handleClickSearchBar}>
            <SearchBar.Input
              ref={searchInputRef}
              disabled={disabled}
              onChange={handleSearch}
              value={searchQuery}
              placeholder={placeholder || t('searchBar.placeholder')}
            />
          </SearchBar.InputContainer>
          {hasClose && searchQuery.length > 0 && (
            <SearchBar.CloseSearch onClick={clearSearch} src="/images/search-bar/input-clean.svg" />
          )}
        </SearchBar>
      )}
    </>
  );
};

export default Search;
